export const typographyfontText = {
  mb: '8px',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '20.27px'
};

export const typographyfontTextHeader = {
  fontWeight: '700',
  fontSize: '14px',
  lineHeight: '14px'
};

export const borderCalendar = {
  border: '1px solid',
  borderColor: '#E6E9ED',
  boxSizing: 'border-box'
};

export const sizeBoxCalendar = {
  maxWidth: '28px',
  maxHeight: '28px',
};

export const sizeBoxCalendarSelected = {
  maxWidth: '24px',
  maxHeight: '24px',
};

export const defaultHeaderNotDoctor = {
  bgcolor: '#AAB2BD',
  color: '#FFFFFF',
  fontWeight: '700',
  fontSize: '12px',
  lineHeight: '14.4px'
}

export const defaultHeaderOP = {
  bgcolor: '#E6E9ED',
  color: '#656D78',
  fontWeight: '400',
  fontSize: '12px',
  lineHeight: '14.4px'
}

export const defaultBodyContentMeeting = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  fontSize: '10px',
  fontWeight: 400,
  lineHeight: '12px'
}

export const stickyHeader = {
  position: 'sticky',
  top: 0,
  backgroundColor: '#FFFFFF',
  zIndex: 2
}

export const stickyCol = {
  position: 'sticky',
  left: 0,
  backgroundColor: '#FFFFFF',
  zIndex: 1
}

export const fontNote = {
  fontSize: '10px',
  lineHeight: '12px',
  whiteSpace: 'pre-line',
  wordBreak: 'break-word',
  overflowWrap: 'break-word'
}

export const sizeColumn = {
  minWidth: '140px',
  maxWidth: '140px'
}

